import { getCurrentDay } from "../utils/date";

export const APP_ROUTES = {
  DASHBOARD: "/",
  PRODUCT: "/product",
  ACCOUNT: {
    ROOT: "/account",
    // SUBSCRIBED: "/account/subscribed",
  },
  NOTIFICATIONS: {
    ROOT: "/notifications/templates",
    PREORDERS: {
      ROOT: "/notifications/templates/pre-order",
      EMAIL: "/notifications/templates/pre-order/email",
      SMS: "/notifications/templates/pre-order/sms",
      SHIPPING_EMAIL: "/notifications/templates/pre-order/shipping-email",
    },
    BACKINSTOCK: {
      ROOT: "/notifications/templates/back-in-stock",
      EMAIL: "/notifications/templates/back-in-stock/email",
    },
  },
  ORDERS: {
    ROOT: "/orders",
    NOTIFICATIONS: "/orders/notifications",
  },
  PRE_ORDER: "/product/new/pre-order",
  NEW_PRODUCT: "/product/new",
  PRODUCTS: {
    ROOT: "/products",
    PREORDERS: "/products/pre-orders",
    BACKINSTOCK: "/products/back-in-stock",
    COMINGSOON: "/products/coming-soon",
    INSTOCK: "/products/in-stock",
    VARIANT: "/products/:productId/variants/:variantId",
    ADD: {
      ROOT: "/products/add",
      PREORDERS: "/products/add/pre-orders",
      BACKINSTOCK: "/products/add/back-in-stock",
      COMINGSOON: "/products/add/coming-soon",
      INSTOCK: "/products/add/in-stock",
    },
  },
  SETTINGS: {
    ROOT: "/settings",
    TEMPLATES: "/settings/templates",
    ADVANCED: {
      ROOT: "/settings/advanced",
      SELECTORS: "/settings/advanced/selectors",
    },
    SELLING_PLANS: "/settings/selling-plans",
    TEMPLATE: {
      BUTTON: "/button",
      MESSAGE: "/message",
      BADGE: "/badge",
      TIMER: "/timer",
      CART: "/cart",
      FORM: "/form",
    },
  },
  BACKINSTOCK: "/back-in-stock/notifications",
  INTEGRATIONS: "/integrations",
  ACTIVITY_LOG: "/activity-log",
  AUTOMATIONS: {
    ROOT: "/automations",
    // BULK_EDIT: "/automations/bulk-edit",
    TAGS: "/automations/tags",
  },
  // Auth
  AUTH_SHOPIFY_CALLBACK: "/auth/signin/shopify/callback",
  AUTH_SHOPIFY_SESSION: "/auth/signin/shopify/session",
  CUSTOMERS: "/customers",
};

// Account plans
export const FREE = "FREE";
export const STARTER = "STARTER";
export const ADVANCED = "ADVANCED";
export const CUSTOM = "CUSTOM";

export const TIMESACT_VERSION_2 = 2;

// Account price plans
export const MONTH = "month";
export const YEAR = "year";
export const MONTH_LABEL = "/mo";
export const YEAR_LABEL = "/yr";
export const MONTH_INTERVAL = "EVERY_30_DAYS";
export const YEAR_INTERVAL = "ANNUAL";
export const STARTER_MONTH_PRICE = 29.0;
export const STARTER_YEAR_PRICE = 290.0;
export const STARTER_PREV_YEAR_PRICE = 348.0;
export const ADVANCED_MONTH_PRICE = 49.0;
export const ADVANCED_YEAR_PRICE = 490.0;
export const ADVANCED_PREV_YEAR_PRICE = 588.0;

// Default values for unlimited.
export const UNLIMITED_PREORDERS = 10000;
export const UNLIMITED_INSTOCK = 100000;
export const UNLIMITED_BIS = 100000;

export const PREORDER_PLAN = [
  { value: 0, label: "0", price: 0, preorders: 0 },
  { value: 10, label: "10", price: 7, preorders: 10 },
  { value: 20, label: "25", price: 11, preorders: 25 },
  { value: 30, label: "50", price: 17, preorders: 50 },
  { value: 40, label: "100", price: 23, preorders: 100 },
  { value: 50, label: "150", price: 35, preorders: 150 },
  { value: 60, label: "250", price: 60, preorders: 250 },
  { value: 70, label: "500", price: 120, preorders: 500 },
  { value: 80, label: "1000", price: 180, preorders: 1000 },
  { value: 90, label: "Unlimited", price: 240, preorders: UNLIMITED_PREORDERS },
];

export const INSTOCK_PLAN = [
  { value: 0, label: "0", price: 0, instock: 0 },
  { value: 10, label: "10", price: 7, instock: 10 },
  { value: 20, label: "25", price: 11, instock: 25 },
  { value: 30, label: "50", price: 17, instock: 50 },
  { value: 40, label: "100", price: 23, instock: 100 },
  { value: 50, label: "150", price: 35, instock: 150 },
  { value: 60, label: "250", price: 60, instock: 250 },
  { value: 70, label: "500", price: 120, instock: 500 },
  { value: 80, label: "1000", price: 180, instock: 1000 },
  { value: 90, label: "Unlimited", price: 240, instock: UNLIMITED_INSTOCK },
];

export const BIS_PLAN = [
  { value: 0, label: "0", price: 0, notifications: 0 },
  { value: 10, label: "500", price: 7, notifications: 500 },
  { value: 20, label: "1000", price: 11, notifications: 1000 },
  { value: 30, label: "2500", price: 17, notifications: 2500 },
  { value: 40, label: "5000", price: 23, notifications: 5000 },
  { value: 50, label: "7500", price: 35, notifications: 7500 },
  { value: 60, label: "15000", price: 60, notifications: 15000 },
  { value: 70, label: "30000", price: 120, notifications: 30000 },
  { value: 80, label: "50000", price: 180, notifications: 50000 },
  { value: 90, label: "Unlimited", price: 240, notifications: UNLIMITED_BIS },
];

export const DYNAMIC_TIMESACT_PLANS = [
  { price: 1, priceWithDiscount: 1, po: 5, bis: 25, is: 5 },
  { price: 7, priceWithDiscount: 6.65, po: 10, bis: 100, is: 10 },
  { price: 11, priceWithDiscount: 10.45, po: 25, bis: 250, is: 25 },
  { price: 17, priceWithDiscount: 16.15, po: 50, bis: 500, is: 50 },
  { price: 23, priceWithDiscount: 20.7, po: 100, bis: 1000, is: 100 },
  { price: 35, priceWithDiscount: 31.5, po: 150, bis: 1500, is: 150 },
  { price: 60, priceWithDiscount: 51, po: 250, bis: 2500, is: 250 },
  { price: 120, priceWithDiscount: 96, po: 500, bis: 5000, is: 500 },
  { price: 180, priceWithDiscount: 144, po: 1000, bis: 10000, is: 1000 },
  {
    price: 240,
    priceWithDiscount: 180,
    po: UNLIMITED_PREORDERS,
    bis: UNLIMITED_BIS,
    is: UNLIMITED_INSTOCK,
  },
];

export const FIXED_TIMESACT_PLANS = [
  { type: "basic", monthly: 19, annual: 14 * 12, discount: 26.32 },
  { type: "professional", monthly: 39, annual: 29 * 12, discount: 25.64 },
  { type: "unlimited", monthly: 59, annual: 49 * 12, discount: 16.95 },
  { type: "shopify_plus", monthly: 99, annual: 89 * 12, discount: 10.1 },
];

export const SUBSCRIPTION_INTERVALS = {
  MONTHLY: "monthly",
  ANNUAL: "annual",
};

export const OLD_USER_TIMESTAMP = 1666700598;

export const DATABASE_STATUTES = {
  NOT_LOADED: "NOT_LOADED",
  LOADING: "LOADING",
  LOADED: "LOADED",
  LOADED_ERROR: "LOADED_ERROR",
  IN_PROGRESS: "IN_PROGRESS",
};

// product constants
// tab types
export const BY_PRODUCT = "by product";
export const BY_COLLECTION = "by collection";
export const BY_ATTRIBUTES = "by attributes";
export const PRODUCT_TYPE = "products";
export const COLLECTION_TYPE = "collections";
export const TAG_TYPE = "tags";
export const VENDOR_TYPE = "vendor";

// NO_SET status
export const NO_SET = "NO_SET";

// pre-order settings
export const DEFAULT_SETTINGS = "DEFAULT";
export const PRE_ORDER_MESSAGE_BELOW = "BELOW";

export const SELLING_PLAN_TYPE = {
  CREATE: "CREATE",
  EXISTING: "EXISTING",
};

// discount options
export const DEFAULT_DISCOUNT = 0;
export const DISCOUNT_TYPES = {
  FIXED: "FIXED",
  PERCENT: "PERCENT",
};

export const DISCOUNT_VALUES = {
  FIXED: "$",
  PERCENT: "%",
};

export const DISCOUNT_OPTIONS = [
  {
    label: "Amount",
    value: "FIXED",
  },
  {
    label: "Percentage",
    value: "PERCENT",
  },
];

export const DISCOUNT_SUFFIX = {
  FIXED: "USD",
  PERCENT: "%",
};

// Shipping date options.
export const PERIOD_TYPES = ["DAY", "WEEK", "MONTH"];

export const SHIPPING_DATE_TYPES = {
  NO_SET: "NO_SET",
  DATE: "DATE",
  PERIOD: "PERIOD",
  INTERVAL: "INTERVAL",
};

export const SHIPPING_DATE_OPTIONS = [
  { label: "Not set (Order status will be ‘Unfulfilled’)", value: SHIPPING_DATE_TYPES.NO_SET },
  { label: "Date (Order status will be ‘Scheduled’)", value: SHIPPING_DATE_TYPES.DATE },
  { label: "Period (Order status will be ‘On hold’)", value: SHIPPING_DATE_TYPES.PERIOD },
  { label: "Interval (Order status will be ‘On hold’)", value: SHIPPING_DATE_TYPES.INTERVAL },
];

// Stock management options.
export const STOCK_OPTIONS = {
  STOCK_1: "stock1",
  STOCK_2: "stock2",
  STOCK_3: "stock3",
};

// Billing policy options.
export const BILLING_POLICY = {
  FULL_AMOUNT: "FULL_AMOUNT",
  PARTIAL_PAYMENT: "PARTIAL_PAYMENT",
};

// Billing policy partial payment options.
export const BILLING_POLICY_PARTIAL_TYPE = {
  DATE: "DATE",
  TIME_AFTER_CHECKOUT: "AFTER_CHECKOUT",
};

// Billing policy partial payment options.
export const INVENTORY_POLICY = {
  ON_FULFILLMENT: "ON_FULFILLMENT",
  ON_SALE: "ON_SALE",
};

// Billing policy - final payment checkout types.
export const BILLING_POLICY_FULL_PAYMENT_CHECKOUT_TYPE = {
  DAYS: "DAY",
  WEEKS: "WEEK",
  MONTHS: "MONTH",
};

export const colorPattern = /^#(?:[0-9a-fA-F]{3}){1,2}$/;

export const ONBOARDING_URL = "https://calendly.com/timesact_onboarding/30min";

// Settings contants
export const SETTINGS_TYPE = {
  PO: "PO",
  BIS: "BIS",
  CS: "CS",
  IS: "IS",
};

const defaultButtonStyle = {
  backgroundColor: "#FFF",
  borderColor: "#000",
  borderRadius: 30,
  borderWidth: 2,
  fontColor: "#000",
  fontSize: 18,
  fontWeight: 100,
  fontStyle: "normal",
  height: 50,
  width: 250,
};

const DAY_SECONDS = 24 * 60 * 60 * 1000;
export const MONTH_SECONDS = 30 * 24 * 60 * 60 * 1000;
const TWO_HOURS_MINUTES = 120;

export const TIMER_TABS = {
  CONTENT: "Content",
  STYLE: "Style",
  PLACEMENT: "Placement",
};

export const TIMER_DATE_TYPES = {
  CURRENT: "CURRENT",
  FIXED: "FIXED",
};

export const TIMER_START_AT = {
  NOW: "NOW",
  LATER: "LATER",
};

export const TIMER_END_AT = {
  DATE: "DATE",
  END_DATE: "END_DATE",
  SHIPPING_DATE: "SHIPPING_DATE",
};

export const ONCE_IT_ENDS_OPTIONS = {
  UNPUBLISH_TIMER: "unpublish-timer",
  REPEAT_COUNTDOWN: "repeat-the-countdown",
  SHOW_TITLE: "show-custom-title",
  DO_NOTHING: "do-nothing",
};

export const defaultMessageTimer = {
  isEnabled: false,
  content: {
    title: "Hurry up!",
    subheading: "Sale ends in:",
    labels: {
      days: "Days",
      hours: "Hrs",
      mins: "Mins",
      secs: "Secs",
    },
    dates: {
      type: TIMER_DATE_TYPES.FIXED, // "FIXED"
      startAt: TIMER_START_AT.NOW,
      startDate: new Date(),
      endAt: TIMER_END_AT.DATE,
      endDate: new Date(new Date().getTime() + DAY_SECONDS - 1),
      minutes: TWO_HOURS_MINUTES,
    },
    onceItEnds: {
      value: ONCE_IT_ENDS_OPTIONS.UNPUBLISH_TIMER,
      options: [
        ONCE_IT_ENDS_OPTIONS.UNPUBLISH_TIMER,
        ONCE_IT_ENDS_OPTIONS.REPEAT_COUNTDOWN,
        ONCE_IT_ENDS_OPTIONS.SHOW_TITLE,
        ONCE_IT_ENDS_OPTIONS.DO_NOTHING,
      ],
      customTitle: "",
    },
  },
  style: {
    container: {
      background: "#2c2e4a",
      borderRadius: 8,
      borderSize: 0,
      borderColor: "#FFF",
      paddingTop: 30,
      paddingBottom: 30,
      marginTop: 20,
      marginBottom: 20,
    },
    title: {
      fontSize: 30,
      color: "#c4c6e3",
    },
    subheading: {
      fontSize: 18,
      color: "#bdc3fb",
    },
    timer: {
      fontSize: 44,
      color: "#E84545",
    },
    labels: {
      fontSize: 14,
      color: "#bdc3fb",
    },
  },
  placement: "BELOW",
};
export const DEFAULT_LOCALE = "en-US";

export const LOCALES = {
  [DEFAULT_LOCALE]: "English",
  "fr-FR": "French",
  "vi-VN": "Vietnamese",
  "zh-CN": "Chinese (Simplified Han, China)",
  "zh-TW": "Chinese (Traditional Han, Taiwan)",
  "cs-CZ": "Czech",
  "da-DK": "Danish",
  "de-DE": "German",
  "es-ES": "Spanish",
  "fi-FI": "Finnish",
  "it-IT": "Italian",
  "ja-JP": "Japanese",
  "ko-KR": "Korean",
  "nl-NL": "Dutch",
  "no-NO": "Norwegian",
  "pl-PL": "Polish ",
  "pt-BR": "Portuguese (Brazil)",
  "pt-PT": "Portuguese (Portugal)",
  "ro-RO": "Romanian",
  "sv-SE": "Swedish",
  "de-CH": "Swiss",
  "th-TH": "Thai",
  "tr-TR": "Turkish",
};

const defaultMessage = {
  type: "BELOW",
  value: "",
  fontColor: "#000",
  fontSize: 16,
  fontWeight: 100,
  fontStyle: "normal",
  textAlign: "left",
  timer: defaultMessageTimer,
  locale: DEFAULT_LOCALE,
};

export const defaultBadgePosition = {
  top: true,
  right: true,
};

const defaultBadgeStyle = {
  backgroundColor: "#79a70a",
  fontColor: "#ffffff",
  fontSize: 10,
  product: false,
  collection: true,
  ...defaultBadgePosition,
};

export const defaultPOSettings = {
  button: {
    name: "Pre-order",
    addToCartText: "Add to Cart",
    soldOutText: "Sold Out",
    type: "DEFAULT",
    style: defaultButtonStyle,
    collection: {
      isEnabled: true,
    },
  },
  cart: {
    labelText: {
      isEnabled: true,
      key: "Pre-order item",
      value: "Delivers as soon as available",
    },
    mixed: {
      isEnabled: false,
      header: "Important Notice",
      body: "Because your cart contains both in-stock products and out-of-stock products your order will be shipped when out-of-stock products are restocked.",
      button: "Okay, Got it!",
      stop: "Don't show this message again.",
      buttonBackgroundColor: "#f70427",
      buttonFontColor: "#FFFFFF",
      onButtonClick: false,
      onCartPage: true,
    },
    alert: {
      isEnabled: false,
      header: "Important Notice",
      body: "By placing this order you acknowledge that you are informed about and agree to our shipping policy, our terms of service and our refund policy.",
      button: "I agree",
      stop: "Don't show this message again.",
      buttonBackgroundColor: "#f70427",
      buttonFontColor: "#FFFFFF",
      onButtonClick: false,
      onCartPage: true,
    },
  },
  message: defaultMessage,
  badge: {
    ...defaultBadgeStyle,
    value: "Pre-order",
    type: "RIBBON",
  },
  type: SETTINGS_TYPE.PO,
};

export const defaultBISSettings = {
  button: {
    name: "Notify Me When Available",
    addToCartText: "Add to Cart",
    soldOutText: "Sold Out",
    type: "CUSTOM",
    style: defaultButtonStyle,
  },
  form: {
    heading: "Notify me when available",
    description: "We will send you a notification as soon as this product is available again.",
    buttonName: "Notify me",
    note: "We respect your privacy and don't share your email with anybody.",
    messageSuccess: "Succesfully subscribed!",
    messageError: "Something went wrong. Please retry!",
    fontSize: 14,
    headingFontColor: "#000",
    textFontColor: "#212b36",
    buttonFontColor: "#FFF",
    buttonBackgroundColor: "#000",
    fieldsBorderRadius: 0,
    popupBorderRadius: 0,
    isBrandEnabled: true,
    isNewsletterEnabled: true,
    messageNewsletter: "Subscribe to our newsletter and stay up to date on offers and promotions.",
  },
  message: defaultMessage,
  badge: {
    ...defaultBadgeStyle,
    value: "NOTIFY ME",
    type: "ROUNDED",
  },
  type: SETTINGS_TYPE.BIS,
};

export const defaultCSSettings = {
  button: {
    name: "Coming SOON",
    addToCartText: "Add to Cart",
    soldOutText: "Sold Out",
    type: "CUSTOM",
    style: defaultButtonStyle,
  },
  message: defaultMessage,
  badge: {
    ...defaultBadgeStyle,
    value: "Coming SOON",
    type: "ROUNDED",
  },
  type: SETTINGS_TYPE.CS,
};

export const defaultISSettings = {
  button: {
    name: "Add to Cart",
    addToCartText: "Add to Cart",
    soldOutText: "Sold Out",
    type: "DEFAULT",
    style: defaultButtonStyle,
    collection: {
      isEnabled: true,
    },
  },
  cart: {
    labelText: {
      isEnabled: true,
      key: "In Stock item",
      value: "Please allow 1-2 days for delivery.",
    },
    alert: {
      isEnabled: false,
      header: "Important Notice",
      body: "By placing this order you acknowledge that you are informed about and agree to our shipping policy, our terms of service and our refund policy.",
      button: "I agree",
      stop: "Don't show this message again.",
      buttonBackgroundColor: "#f70427",
      buttonFontColor: "#FFFFFF",
      onButtonClick: false,
      onCartPage: true,
    },
  },
  message: defaultMessage,
  badge: {
    ...defaultBadgeStyle,
    value: "In Stock",
    type: "RIBBON",
  },
  type: SETTINGS_TYPE.IS,
};

export const tabsBySettingsType = {
  PO: new Set(["Button", "Message", "Cart", "Badge", "Timer"]),
  BIS: new Set(["Button", "Form", "Message", "Badge", "Timer"]),
  CS: new Set(["Button", "Message", "Badge"]),
  IS: new Set(["Button", "Message", "Cart", "Badge", "Timer"]),
};

// Automations

const defaultPOEmailContactValues = {
  isEnabled: true,
  text: "Questions About Your Order?",
  buttonName: "Contact Us",
  buttonSrc: "", // https://" + shop.uid",
  buttonBackgroundColor: "#000",
  buttonFontColor: "#FFF",
};

export const EMAIL_NOTIFICATION_DYNAMIC_VARIABLES = {
  PRODUCT_NAME: "productName",
  DELAY_TIME: "delayTime",
  CANCELLATION_LINK: "cancellationLink",
};

export const defaultPOEmailValues = {
  id: null,
  isEnabled: false,
  name: "Pre-order",
  replyTo: "",
  action: {
    subject: "Confirmation for Order $orderId",
    title:
      '<p class="ql-align-center"><span style="font-size: 32px;">Pre-Order Confirmation</span></p><p class="ql-align-center"><br></p><p class="ql-align-center"><span style="font-size: 20px;">Order Number: $orderId</span></p>',
    header:
      '<h4 class="ql-align-center">Hi there,</h4><p class="ql-align-center">We would like to let you know that the order contains pre-order items. Below are the details:</p>',
    bodyHeader: "Pre-order items",
    footer:
      '<p class="ql-align-center">Please contact customer support if you have any questions. Thanks!</p><p class="ql-align-center"><br></p><p class="ql-align-center">Sincerely,</p><p class="ql-align-center">Customer Support</p>',
    contact: defaultPOEmailContactValues,
    cancelOrderEnabled: false,
    cancelOrderText: `If you change your mind you can cancel the pre-order here: $${EMAIL_NOTIFICATION_DYNAMIC_VARIABLES.CANCELLATION_LINK}`,
  },
  logo: "",
  isBrandEnabled: false,
};

export const defaultPOSMSValues = {
  id: null,
  isEnabled: false,
  action: {
    body: "Order $orderId contains pre-order items. Thanks, Customer Support",
  },
};

export const defaultBISEmailValues = {
  id: null,
  isEnabled: false,
  name: "Back In Stock",
  replyTo: "",
  action: {
    subject: "Your product just came back in stock",
    body: "<h1 class='ql-align-center'>$productName</h1><p><br></p><p><strong>Hi there,</strong></p><p>We wanted to let you know that your product just came back in stock. Because you asked, we made sure that you're the first to know, but we can't guarantee your item will say available for long. Hit the link below to get your gear before its gone!</p>",
    buttonName: "Buy It Now",
    buttonBackgroundColor: "#212b36",
    buttonFontColor: "#FFF",
    emailBackgroundColor: "#F8F9FA",
    contact: {
      text: "Visit our store",
      backgroundColor: "#212b36",
      fontColor: "#FFF",
      isWebsiteEnabled: true,
      websiteLink: "",
      isFacebookEnabled: false,
      facebookLink: "",
      isInstagramEnabled: false,
      instagramLink: "",
      isTwitterEnabled: false,
      twitterLink: "",
    },
  },
  logo: "",
  isBrandEnabled: false,
};

export const defaultPOShippingDelayEmailValues = {
  id: null,
  isEnabled: false,
  name: "Pre-order",
  replyTo: "",
  action: {
    subject: "Pre-order shipping delayed",
    body: "<h2 class='ql-align-center'>Pre-order $orderId</h2><p><br></p><p><strong>Hi there,</strong></p><p>Due to some unforeseen developments on our end your order will be shipped later than stated in the original delivery date note. We apologize for any inconvenience this may cause you and wish to thank you for your patience and support.</p><p><br></p><p>Kind Regards,</p><p>The Support Team</p>",
    buttonName: "Contact Us",
    buttonBackgroundColor: "#212b36",
    buttonFontColor: "#FFF",
    emailBackgroundColor: "#F8F9FA",
    contact: {
      text: "Visit our store",
      backgroundColor: "#212b36",
      fontColor: "#FFF",
      isWebsiteEnabled: true,
      websiteLink: "",
      isFacebookEnabled: false,
      facebookLink: "",
      isInstagramEnabled: false,
      instagramLink: "",
      isTwitterEnabled: false,
      twitterLink: "",
    },
    cancelOrderEnabled: false,
    cancelOrderText: `If you change your mind you can cancel the pre-order here: $${EMAIL_NOTIFICATION_DYNAMIC_VARIABLES.CANCELLATION_LINK}`,
  },
  logo: "",
  isBrandEnabled: false,
};

export const TUTORIAL_PAGE_URL = "https://www.youtube.com/watch?v=ikX8ynlEU2E";

export const SETTINGS_DYNAMIC_VARIABLES = {
  PREORDER_QUANTITY: "preorderQuantity",
  SHIPPING_DATE: "shippingDate",
  DAYS_LEFT_UNTIL_SHIPPING_DATE: "daysLeftUntilShippingDate",
  DAYS_LEFT_UNTIL_PREORDER_END_DATE: "daysLeftUntilPreorderEndDate",
};

// ORDERS
export const ORDERS_CHUNK_LIMIT = 50;
export const PREORDER_NOTIFICATIONS_CHUNK_LIMIT = 50;

export const TUTORIAL_LINK = "https://www.youtube.com/channel/UCKexlUcGdQRIkw1-Y7WcODg/videos";

export const PRODUCT_TABLE_FILTER_OPTIONS = {
  DISCOUNT: "discount",
  TEMPLATE_TYPE: "templateType",
  SHIPPING_TYPE: "shippingType",
  START_DATE: "startDate",
  TAGS: "tags",
  VENDORS: "vendors",
  SELLING_PLAN: "sellingPlan",
};

export const SHOP_PLAN_TYPE = "plan-type";
export const PARTNER_TEST_PLAN = "partner_test";

const SUPPORT_EMAIL_SUBJECT = "";
const SUPPORT_EMAIL_BODY = "";
// const SUPPORT_EMAIL_BODY = "The message’s first paragraph.%0A%0ASecond paragraph.%0A%0AThird Paragraph.";
export const SUPPORT_EMAIL = "support@timesact.com";
export const SUPPORT_EMAIL_LINK = `mailto:${SUPPORT_EMAIL}?subject=${SUPPORT_EMAIL_SUBJECT}&body=${SUPPORT_EMAIL_BODY}`;
export const PAGEFLY_LINK = "https://pagefly.link/DyzPMFDg";

export const ACCOUNT_PRE_ORDERS_QUANTITY = "account-pre-orders-quantity";
export const ACCOUNT_BIS_NOTIFICATIONS_QUANTITY = "account-bis-notifications-quantity";
export const ACCOUNT_IS_QUANTITY = "account-is-quantity";

export const BUTTON_WIDTH_HEIGHT_TYPES = {
  FIXED: "FIXED",
  PERCENT: "PERCENT",
};

export const BUTTON_WIDTH_HEIGHT_VALUES = {
  FIXED: "px",
  PERCENT: "%",
};

export const BUTTON_WIDTH_HEIGHT_OPTIONS = [
  {
    key: "pixels",
    label: "Pixels",
    value: "FIXED",
  },
  {
    key: "percentage",
    label: "Percentage",
    value: "PERCENT",
  },
];

export const REVIEW_LINK = "https://apps.shopify.com/timesact-discount-pre-order#modal-show=WriteReviewModal";

export const SETTING_GLOBAL_NAMES = {
  PO: "Pre-order Global",
  BIS: "Back In Stock Global",
  CS: "Coming Soon Global",
  IS: "In Stock Global",
};
export const SELLING_PLAN_FULL_PAYMENT_OPTIONS = "Pre-order: pay in full";
export const SELLING_PLAN_PARTIAL_PAYMENT_OPTIONS = "Partial payment: 10% deposit";

export const defaultSellingPlan = {
  discount: 0,
  discountType: DISCOUNT_TYPES.FIXED,
  description: "",
  sellingPlanName: "Pre-order item delivers as soon as available.",
  sellingPlanOptions: SELLING_PLAN_PARTIAL_PAYMENT_OPTIONS,
  inventoryPolicy: INVENTORY_POLICY.ON_SALE,
  billingPolicy: {
    type: BILLING_POLICY.FULL_AMOUNT,
    upfrontPayment: {
      type: DISCOUNT_TYPES.PERCENT,
      value: 0,
    },
    finalPayment: {
      type: BILLING_POLICY_PARTIAL_TYPE.DATE,
      date: getCurrentDay(),
      afterCheckout: {
        type: BILLING_POLICY_FULL_PAYMENT_CHECKOUT_TYPE.DAYS,
        value: 1,
      },
    },
  },
  shippingDate: {
    type: SHIPPING_DATE_TYPES.NO_SET,
    date: getCurrentDay(),
    periodType: PERIOD_TYPES[0],
    periodValue: 1,
    periodStart: {
      type: PERIOD_TYPES[0],
      value: 1,
    },
    periodEnd: {
      type: PERIOD_TYPES[0],
      value: 1,
    },
  },
};

export const NO_SELLING_PLAN = "no_selling_plan";

export const ORDER_FINANCIAL_STATUSES = {
  PARTIALLY_PAID: "partially_paid",
  PENDING: "pending",
  PAID: "paid",
};

export const ORDER_FULFILLMENT_STATUSES = {
  ON_HOLD: "ON_HOLD",
  SCHEDULED: "SCHEDULED",
};

export const PAGE_MODES = {
  LOADING: "LOADING",
  EDIT: "EDIT",
  CREATE: "CREATE",
  NOT_FOUND: "NOT_FOUND",
};

export const NOT_FOUND = "NOT_FOUND";

export const DEFAULT_PRODUCT_FILTER_VALUES = {
  startDate: {
    from: null,
    to: null,
  },
  discount: [0, 0],
  discountType: DISCOUNT_TYPES.PERCENT,
  template: "",
  shippingType: "",
  vendors: [],
  tags: [],
  sellingPlan: "",
};

export const DEFAULT_TAG_FILTER_VALUES = {
  startDate: {
    from: null,
    to: null,
  },
  settings: [],
};

export const APPS_CATEGORIES = {
  "Integration apps": "Integration",
  "Recommended apps": "Recommended",
  "Page builder apps": "Page builder",
  "Review apps": "Reviews",
  "Translation apps": "Translation",
  "Bundle apps": "Bundle",
  "Email apps": "Email",
  "Pop-up apps": "Pop-up",
  "Loyalty apps": "Loyalty",
  "Chat apps": "Chat",
  "Order tracking apps": "Order tracking",
  "Back in stock (SMS & store-wide setting) apps": "Back in stock",
};

// ---------------
export const REWARD_TIMEOUT_STR = "cancel-reward-timeout";

export const ACCOUNT_OFFER_2024_DATE = new Date(2024, 0, 1, 0, 0, 1);

export const ROWS_PER_PAGE = [5, 10, 25];

export const AGENCY_USER = {
  name: "Robert Onesim",
  position: "Co-founder & CTO at Timesact - Ex L5 Google Zurich",
  avatarUrl: "/assets/agency-avatar.webp",
  actions: [
    {
      name: "Email",
      icon: "eva:email-outline",
      iconColor: "#FF4842",
      path: "mailto:ronesim@itechhub.ch",
      target: "_blank",
    },
    {
      name: "LinkedIn",
      icon: "eva:linkedin-fill",
      iconColor: "#007EBB",
      path: "https://www.linkedin.com/in/robert-onesim/",
      target: "_blank",
    },
    {
      name: "Calendly",
      icon: "simple-icons:calendly",
      iconColor: "#00AAEC",
      path: "http://link.itechhub.ch/calendly",
      target: "_blank",
    },
  ],
};

export const AGENCY_USER_NEW = {
  name: "Robert Onesim",
  position: "Reach out to Co-founder & CTO Robert Onesim",
  avatarUrl: "/assets/agency-avatar.webp",
  actions: [
    { label: "Get in Touch", value: "inTouch" },
    {
      name: "Email",
      label: "Email",
      value: "email",
      path: "mailto:ronesim@itechhub.ch",
      target: "_blank",
    },
    {
      name: "LinkedIn",
      label: "View LinkedIn",
      value: "linkedIn",
      path: "https://www.linkedin.com/in/robert-onesim/",
      target: "_blank",
    },
    {
      name: "Calendly",
      label: "Book calendly",
      value: "calendly",
      path: "http://link.itechhub.ch/calendly",
      target: "_blank",
    },
  ],
};

export const AGENCY_SUPPORT = {
  actions: [
    { label: "Get Support", value: "inTouch" },
    {
      name: "Chat",
      label: "Start Chat",
      value: "chat",
      // icon: "eva:email-outline",
      // iconColor: "#FF4842",
      path: "window.$crisp.push",
      target: "_blank",
    },
    {
      name: "Email",
      label: "Email",
      value: "email",
      // icon: "eva:email-outline",
      // iconColor: "#FF4842",
      path: "mailto:ronesim@itechhub.ch",
      target: "_blank",
    },
  ],
};

export const UNLIMITED_PLAN_END_DATE_STR = "unlimited-plan-offer-end-date";

export const AUTOMATION_TYPES = {
  TAGS: "TAGS",
};

export const PRODUCT_CONFIG_MODES = {
  TAG_CREATE: "tag_create",
  TAG_EDIT: "tag_edit",
  TAG_VIEW: "tag_view",
  PRODUCT_CREATE: "product_create",
  PRODUCT_EDIT: "product_edit",
};

export const AXIOS_REQUEST_ERROR_CANCELLATION = "ERR_CANCELED";
export const FETCH_SIGNAL_ABORT_REASON = "Stale request!";

export const TAG_AUTOMATION_TUTORIALS_URL = "https://www.youtube.com/playlist?list=PLz4HfRMsZFWBicZVkgsTOHNhCTIjF36H4";
export const LINK_TO_BOOK_CALL = "http://link.itechhub.ch/calendly";
export const ONBOARDING_WITH_FOUNDERS =
  "https://calendly.com/timesact_onboarding/office-hours-with-the-timesact-founders";
